export default "/images/a9635d2833d4a6831d12bd0d6ac24e92.jpg";